import { useState, useEffect, ComponentProps } from 'react';
import { Platform, ViewStyle } from 'react-native';
import SliderLib from '@react-native-community/slider';

type Props = ComponentProps<typeof SliderLib>;
export const Slider = ({ style, ...props }: Props) => {
	// https://github.com/callstack/react-native-slider/issues/470#issuecomment-1777525861
	const [tempStyle, setTempStyle] = useState<ViewStyle>({
		width: 0,
		height: 0,
	});

	useEffect(() => {
		setTempStyle({ width: undefined, height: undefined });
	}, []);

	return <SliderLib style={[Platform.OS === 'web' ? tempStyle : undefined, style]} {...props} />;
};
